export enum McbGridSearchOperator {
  EQUALS = "EQUALS" ,
  IN = "IN",
  BETWEEN = "BETWEEN",
  LIKE = "LIKE",
  LESS_THAN_OR_EQUAL_TO = "LESS_THAN_OR_EQUAL_TO",
  LESS_THAN = "LESS_THAN",
  LARGER_THAN_OR_EQUAL_TO = "LARGER_THAN_OR_EQUAL_TO",
  LARGER_THAN = "LARGER_THAN"
}
